export default String.raw`
<div class="coupons-list-js container-js" data-template="partials/customer-profile/discounts/coupon-details.html">
    {% include 'partials/customer-profile/discounts/coupon-list.html' -%}
</div>

`